import TimeDatePicker from "./TimeDatePicker/index.vue";

const components  = [TimeDatePicker];


// 定义install方法
const install = function (Vue) {
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}
// 判断是否直接引入文件，如果是，就不用调用Vue.use()
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
// 导出install方法
export default {
  install
}
